/**
 * Audit Log Service
 * Handles API requests for audit logs
 */

import { apiService } from '../api/ApiService';
import type { AuditLogFilters, PagedAuditLogResponse } from '../../types/auditLog';

interface ApiResponse<T> {
    isSuccess: boolean;
    data: T;
    message?: string;
}

export const AuditLogService = {
    /**
     * Get paginated audit logs with filters
     */
    getAuditLogs: async (filters: AuditLogFilters): Promise<PagedAuditLogResponse> => {
        const params = new URLSearchParams();

        if (filters.actionType) {
            params.append('actionType', filters.actionType);
        }
        if (filters.actorId) {
            params.append('actorId', filters.actorId);
        }
        if (filters.startDate) {
            params.append('startDate', filters.startDate);
        }
        if (filters.endDate) {
            params.append('endDate', filters.endDate);
        }
        if (filters.actionStatus) {
            params.append('actionStatus', filters.actionStatus);
        }
        params.append('page', String(filters.page || 1));
        params.append('pageSize', String(filters.pageSize || 20));

        const queryString = params.toString();
        const url = `/admin/audit-logs${queryString ? `?${queryString}` : ''}`;

        const response = await apiService.get<ApiResponse<PagedAuditLogResponse>>(url);
        return response.data;
    },
};
